import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStoreon } from 'storeon/react';

import BlockCustomerInfoWarranty from '../../BlockCustomerInfoWarranty';
import BlockContactMethodWarranty from "../../BlockContactMethodWarranty";
import BlockDescribeProblemWarrantyRecallForm from '../../BlockDescribeProblemWarrantyRecallForm';

import BtnWarranty from "../../BtnWarranty";
import InfoWarranty from "../../InfoWarranty";
import axios from "axios";
import Loader from '../../Loader';

const ImpactRecallForm = ( { id} ) => {
    const [serverResponse, setServerResponse] = useState( '' );
    const [submitForm , setSubmitForm] = useState(false);

    const methods = useForm( {
        mode: 'all',
        reValidateMode: 'onChange',
        // Default values for field array.
        defaultValues: {
            your_project: [{}],
        },
    } );
    const { errors, handleSubmit, formState } = methods;

    const onSubmit = ( data ) => {
        const endpointUrl = `${window.location.origin}/sr/api`;
        setSubmitForm(true);

        axios( {
            method: 'post',
            url: endpointUrl,
            data: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        } )
            .then( ( response ) => {
                if ( response.status === 200 ) {
                    window.location.href = `${window.location.origin}/form${window.location.pathname.replace( /\/+$/, '' )}/confirmation`;
                }
            } )
            .catch( ( error ) => {
                setServerResponse( error.response.data );
                setSubmitForm(false);
                console.log( error );
            } );
    }
    const { dispatch, groups } = useStoreon( 'groups' );

    useEffect( () => {
        for ( let i = 1; i < groups.length; i += 1 ) {
            const { fields: groupFields } = groups[i - 1];
            const isValid = !Object.keys( errors ).some( ( item ) => groupFields.includes( item ) );
            if ( groups[i].disabled === isValid ) {
                dispatch( 'CHANGE_FIELDSET_STATE', { id: i, disabled: !isValid } );
            }
        }
    } );

    return (
        <div className={`service-request-form service-request-warranty-form`}>
            <div className={`service-request-form-container`}>
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit( onSubmit )}>
                        <div className={"service-request-form-hero"}>
                            <div className={"service-request-form-hero-container"}>
                                <h1 className={'service-request-form-hero-title'}>Voluntary Recall Form</h1>
                            </div>
                        </div>
                        <div className={"service-request-form-content"}>
                            <InfoWarranty styleText={'text-grey mb-18'}>
                                In line with our two most important values – Safety and Integrity – MI Windows
                                and Doors conducts voluntary recalls on any products that pose a potential risk to
                                owners. If you own a recalled product, please use the form below to file a claim.
                            </InfoWarranty>
                            <BlockCustomerInfoWarranty index={1} number={false}/>
                            <BlockDescribeProblemWarrantyRecallForm index={2} idForm={id}/>
                            <BlockContactMethodWarranty number={false} index={3} placeholder="Please include your order number and, if known, your dealer or installation company’s name."/>
                            <InfoWarranty>
                                After you click Submit, you will receive an email confirmation
                                from MI Windows and Doors. A customer service representative will
                                contact you once they have reviewed the information provided.
                            </InfoWarranty>
                            <BtnWarranty disabled={!formState.isValid || submitForm}><input type="submit" disabled={!formState.isValid || submitForm} value={'Submit Recall Request'}/></BtnWarranty>
                            {serverResponse && <div className="server-error">{serverResponse}</div>}
                        </div>
                    </form>
                </FormProvider>
            </div>
            {submitForm && <Loader />}
        </div>
    );
};

export default ImpactRecallForm;
